<div>
    <div *ngIf ="usersData.size > 0" class="results-counts-info">
        {{ "ACCOUNT_ADMIN.USER_REGISTRATIONS_PAGE.RESULT_COUNT_MESSAGE" | translate:
            {
                begin: (usersData.crntPgNum - 1) * pageSize + 1,
                end: usersData.crntPgNum === usersData.pgsCount ? usersData.size : (usersData.crntPgNum) * pageSize,
                total: usersData.size
            }
        }}
    </div>
    <div class="hvac-table-wrap" >
        <hvac-table class="hvac-registration-table-wrap" [responsive]="true" [theme]="'zebra'">
            <thead>
                <tr>
                    <td class="center-align">
                        <utc-checkbox [checked]="usersData.isSelectAllChecked" (change)="usersData.onSelectAllCheckboxClick()"></utc-checkbox>
                    </td>
                    <td *ngFor="let item of dataHeaders">
                        <button class="hvac-table-sort-btn" (click)="sort(item)">
                            {{item.title}}
                            <span class="hvac-table-list-sort" [ngClass]="{
                                'hvac-table-list-sort-show': item.order,
                                'column-ascending': item.order === 'asc'
                            }">
                                <utc-svg src="assets/icons/chevron-down.svg"></utc-svg>
                            </span>
                        </button>
                    </td>
                </tr>
            </thead>
            <tbody>
                    <tr
                        *ngFor="let userData of usersData.crntPgSlctblUIData; let row=even;"
                        class="user-registration-result-row"
                        [class.user-registration-result-row--active]="isQuickViewDrawerOpen && selectedQuickViewUser?.requestId === userData.data.requestId"
                        (click)="openQuickViewDrawer(userData.data)">
                        <td class="center-align" [attr.data-label]="dataHeaders[8].title" (click)="$event.stopPropagation()">
                            <utc-checkbox [checked]="userData.isSelected" (change)="selectUserRegistration($event, userData.getId())"></utc-checkbox>
                        </td>
                        <td class="center-align" [attr.data-label]="dataHeaders[0].title">
                            {{userData.data.firstName}}
                        </td>
                        <td class="center-align" [attr.data-label]="dataHeaders[1].title">
                            {{userData.data.lastName}}
                        </td>
                        <td class="center-align" [attr.data-label]="dataHeaders[2].title">
                            {{ userData.data.userName ? userData.data.userName : "--"}}
                        </td>
                        <td class="center-align" [attr.data-label]="dataHeaders[3].title">
                            {{ getOwnerCompanyNamePreview(userData.data.ownerCompanyName) }}
                        </td>
                        <td class="center-align" [attr.data-label]="dataHeaders[4].title">
                            {{userData.data.companyName}}
                        </td>
                        <td class="center-align" [attr.data-label]="dataHeaders[5].title">
                            {{userData.data.companyId}}
                        </td>
                        <td class="center-align" [attr.data-label]="dataHeaders[6].title">
                            {{userData.data.createdDate | date: 'MM/dd/yyyy' }}
                        </td>
                        <td class="center-align" [attr.data-label]="dataHeaders[7].title">
                            {{userData.data.userStatus}}
                        </td>
                        <td (click)="onClickReview(userData.data); $event.stopPropagation()" class="center-align" [attr.data-label]="dataHeaders[8].title">
                            <button [hvacButton]="row ? 'default' : 'secondary'" type="button">
                                {{ "ACCOUNT_ADMIN.USER_REGISTRATIONS_PAGE.USER_RESULT_REVIEW" | translate}}
                            </button>
                        </td>
                    </tr>
            </tbody>
        </hvac-table>
        <utc-loading-spinner *ngIf="loading" class="hvac-account-admin-loader" spinnerSize="small"></utc-loading-spinner>
        <div class="footer-controls">
            <div><hvac-pagination
                [useUIData]="true"
                [UIData]="usersData.dataFrPgntn"
                [globalDataHolder]="usersData.dataFrPgntn"
                [currentPage]="usersData.crntPgNum"
                [totalPages]="usersData.pgsCount"
                (pageChange)="onPageChange($event)"
            >
            </hvac-pagination></div>
            <div class="export-controls">
                <button class="control" (click)="usersData.onSelectAllCheckboxClick()" [hvacButton]="'secondary'" type="button">{{ "ACCOUNT_ADMIN.USER_REGISTRATIONS_PAGE.SELECT_ALL_BUTTON_TEXT" | translate}}</button>
                <button class="control" (click)="onExportSelectedClick()" [hvacButton]="'primary'" type="button">{{ "ACCOUNT_ADMIN.USER_REGISTRATIONS_PAGE.EXPORT_BUTTON_TEXT" | translate}}</button>
            </div>
        </div>
    </div>

    <div
        class="user-registration-quick-view-overlay"
        [class.user-registration-quick-view-overlay--active]="isQuickViewDrawerOpen"
        (click)="closeQuickViewDrawer()">
    </div>

    <aside
        class="user-registration-quick-view-drawer"
        [class.user-registration-quick-view-drawer--open]="isQuickViewDrawerOpen"
        [attr.aria-hidden]="!isQuickViewDrawerOpen">
        <div class="user-registration-quick-view-drawer-header">
            <h2 class="user-registration-quick-view-drawer-title">
                {{ "ACCOUNT_ADMIN.USER_REGISTRATIONS_PAGE.USER_SUMMARY" | translate }}
            </h2>
            <button type="button" class="user-registration-quick-view-drawer-close" (click)="closeQuickViewDrawer()">
                <utc-svg src="assets/icons/close.svg"></utc-svg>
                <span class="hvac-accessible-text">{{ "ACCOUNT_ADMIN.CANCEL" | translate }}</span>
            </button>
        </div>

        <div class="user-registration-quick-view-drawer-body" *ngIf="selectedQuickViewUser">
            <dl class="user-registration-quick-view-details">
                <div class="user-registration-quick-view-details-item">
                    <dt>{{ dataHeaders[0].title }}</dt>
                    <dd>{{ selectedQuickViewUser.firstName || "--" }}</dd>
                </div>
                <div class="user-registration-quick-view-details-item">
                    <dt>{{ dataHeaders[1].title }}</dt>
                    <dd>{{ selectedQuickViewUser.lastName || "--" }}</dd>
                </div>
                <div class="user-registration-quick-view-details-item">
                    <dt>{{ dataHeaders[2].title }}</dt>
                    <dd>{{ selectedQuickViewUser.userName || "--" }}</dd>
                </div>
                <div class="user-registration-quick-view-details-item">
                    <dt>{{ dataHeaders[3].title }}</dt>
                    <dd>{{ selectedQuickViewUser.ownerCompanyName || "--" }}</dd>
                </div>
                <div class="user-registration-quick-view-details-item">
                    <dt>{{ dataHeaders[4].title }}</dt>
                    <dd>{{ selectedQuickViewUser.companyName || "--" }}</dd>
                </div>
                <div class="user-registration-quick-view-details-item">
                    <dt>{{ dataHeaders[5].title }}</dt>
                    <dd>{{ selectedQuickViewUser.companyId || "--" }}</dd>
                </div>
                <div class="user-registration-quick-view-details-item">
                    <dt>{{ "ACCOUNT_ADMIN.EMAIL_ADDRESS" | translate }}</dt>
                    <dd>{{ selectedQuickViewUser.email || "--" }}</dd>
                </div>
                <div class="user-registration-quick-view-details-item">
                    <dt>{{ dataHeaders[6].title }}</dt>
                    <dd>{{ selectedQuickViewUser.createdDate | date: 'MM/dd/yyyy' }}</dd>
                </div>
                <div class="user-registration-quick-view-details-item">
                    <dt>{{ dataHeaders[7].title }}</dt>
                    <dd>{{ selectedQuickViewUser.userStatus || "--" }}</dd>
                </div>
            </dl>

            <div class="user-registration-quick-view-drawer-actions">
                <button type="button" [hvacButton]="'primary'" (click)="onQuickViewReviewClick()">
                    {{ "ACCOUNT_ADMIN.USER_REGISTRATIONS_PAGE.USER_RESULT_REVIEW" | translate }}
                </button>
            </div>
        </div>
    </aside>
</div>
